import { render, staticRenderFns } from "./WorkDetailFile.vue?vue&type=template&id=84b5b888&scoped=true"
import script from "./WorkDetailFile.vue?vue&type=script&lang=js"
export * from "./WorkDetailFile.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailFile.vue?vue&type=style&index=0&id=84b5b888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b5b888",
  null
  
)

export default component.exports